import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useState } from 'react'

import type { FC } from 'react'

interface CreateVersionModalProps {
	open: boolean
	onClose: () => void
	onCreateVersion: (versionName: string) => Promise<void>
	onCreateAndActivate: (versionName: string) => Promise<void>
	isLoading?: boolean
}

export const CreateVersionModal: FC<CreateVersionModalProps> = ({
	open,
	onClose,
	onCreateVersion,
	onCreateAndActivate,
	isLoading = false,
}) => {
	const [versionName, setVersionName] = useState('')

	const handleClose = () => {
		setVersionName('')
		onClose()
	}

	const handleCreateVersion = async () => {
		if (!versionName.trim()) return
		try {
			await onCreateVersion(versionName.trim())
			handleClose()
		} catch (error) {
			// Error handling is done in parent component
		}
	}

	const handleCreateAndActivate = async () => {
		if (!versionName.trim()) return
		try {
			await onCreateAndActivate(versionName.trim())
			handleClose()
		} catch (error) {
			// Error handling is done in parent component
		}
	}

	return (
		<Dialog open={open} onOpenChange={handleClose}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>Create Grid Version</DialogTitle>
				</DialogHeader>
				<div className="space-y-4 py-4">
					<div className="space-y-2">
						<Label htmlFor="version-name">Version Name</Label>
						<Input
							id="version-name"
							placeholder="Enter version name"
							value={versionName}
							onChange={(e) => setVersionName(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === 'Enter' && !e.shiftKey) {
									e.preventDefault()
									handleCreateAndActivate()
								}
							}}
						/>
					</div>
				</div>
				<DialogFooter className="flex flex-row justify-end space-x-2">
					<Button variant="outline" onClick={handleClose} disabled={isLoading}>
						Cancel
					</Button>
					<Button
						variant="secondary"
						onClick={handleCreateVersion}
						disabled={!versionName.trim() || isLoading}
					>
						Create version
					</Button>
					<Button onClick={handleCreateAndActivate} disabled={!versionName.trim() || isLoading}>
						Create & activate
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
